<template>
  <div class="apply_box">
    <div class="header">
      <p class="title">
        您的<span class="orange">资质不符合</span>{{ productName }}的准入资格
      </p>
    </div>
    <div class="con">
      <p class="title">
        <span class="title_left"></span> 大数据 助你下款
        <span class="title_right"></span>
      </p>
      <p class="info">
        全网因黑名单被拒的用户高达<span class="red"> 86.7%</span>
      </p>
      <div class="item_box">
        <div class="item">
          <img src="../../assets/img/afterLoan/faile_icon3.png"
               alt="" />
          <p>网黑记录</p>
        </div>
        <div class="item">
          <img src="../../assets/img/afterLoan/faile_icon2.png"
               alt="" />
          <p>逾期记录</p>
        </div>
        <div class="item">
          <img src="../../assets/img/afterLoan/faile_icon1.png"
               alt="" />
          <p>申请记录</p>
        </div>
      </div>
      <span class="btn"
            @click="toPageUrl">查看被拒原因</span>
    </div>
  </div>
</template>

<script>
import LoanList from "@/components/loanList";
export default {
  components: {
    LoanList
  },
  data () {
    return {
      status: "", //失败成功的标志
      productId: "",
      productName: ""
    };
  },
  mounted () {
    this.util.title("资质不符合");
    this.status = this.$route.query.status;
    this.productId = this.$route.query.productId;
    this.getDetails();
    let json = {
      event_key: "H5_aptitude_view"
    };
    this.toCountPoint(json);
  },
  methods: {
    //统计埋点
    toCountPoint (json) {
      this.$get("/app/api/v1/newEventTrace", json)
        .then(res => {
          if (res.code == 200) {
          } else {
            this.util.toast({ msg: res.message });
          }
        })
        .catch(error => { });
    },
    toPageUrl () {
      let json = {
        event_key: "H5_aptitude_query_click"
      };
      this.toCountPoint(json);
      this.$router.push({
        path: '/vip/creditCheck',
        query: {
          webRefresh: '1',
          buyEntrance: '3',
          isShowCheck: '0',
          id: 2
        }
      });
      // this.$router.push({
      //   path: "/vip/creditCheck?buyEntrance=3"
      // });
    },
    getDetails () {
      let param = {
        productId: this.productId
      };
      let _this = this;
      this.$get("/app/api/v1/qualification/view", param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.productName = e.data.productName;
            _this.util.title(_this.productName);
          } else {
            _this.util.toast({ msg: e.msg });
          }
        })
        .catch(error => { });
    }
  }
};
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
}
.header {
  padding: 0.35rem 0 0.15rem 0.19rem;
  background: url('../../assets/img/afterLoan/faile_banner.png') no-repeat top
    center;
  background-size: 100% 100%;
  height: 1.55rem;
  width: 100%;
  color: #fff;
  font-size: 0.14rem;
}
.orange {
  color: #ffd694;
}
.header .title {
  padding: 0.1rem;
  background: rgba(138, 52, 240, 0.08);
  border: 2px solid rgba(255, 255, 255, 0.18);
  display: inline-block;
  width: 70%;
}
.con {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 0 0.15rem;
  padding: 0.2rem 0.2rem 0.3rem 0.2rem;
  position: relative;
  top: -0.35rem;
  text-align: center;
}
.item_box {
  display: flex;
  flex: 1;
  justify-content: space-around;
  margin-bottom: 0.35rem;
}
.item img {
  width: 0.56rem;
  height: 0.56rem;
}
.con .title {
  font-size: 0.16rem;
  color: #333333;
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.1rem;
}
.title_left,
.title_right {
  display: inline-block;
  background: url('../../assets/img/afterLoan/title_left.png') no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.2rem;
  height: 0.14rem;
}
.title_right {
  background: url('../../assets/img/afterLoan/title_right.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.info {
  box-shadow: 0px 0px 11px 0px rgba(71, 123, 248, 0.2);
  border-radius: 4px;
  color: #3189f5;
  font-size: 0.12rem;
  padding: 0.04rem 0.17rem;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 0.15rem;
}
.red {
  color: #ff4d24;
}
.item p {
  color: #666;
  font-size: 0.12rem;
}
.btn {
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  color: #fff;
  font-size: 0.17rem;
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  text-align: center;
}
</style>
